import React, { createContext, useCallback, useContext, useState } from 'react';
import { toast } from 'sonner';
import { applicants as seed } from '../data/applicants';
import type { Applicant, ApplicantStatus } from '../types/applicant';
type ApplicantsContextValue = {
  applicants: Applicant[];
  setStatus: (id: string, status: ApplicantStatus) => void;
};
const ApplicantsContext = createContext<ApplicantsContextValue | null>(null);
const messages: Record<ApplicantStatus, string> = {
  New: 'Marked as new',
  'Under review': 'Moved to review',
  Interview: 'Interview invitation sent',
  'Info requested': 'Request for more information sent',
  Approved: 'Application approved — onboarding email sent',
  Rejected: 'Application declined — applicant notified'
};
export function ApplicantsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [applicants, setApplicants] = useState<Applicant[]>(seed);
  const setStatus = useCallback((id: string, status: ApplicantStatus) => {
    const name = applicants.find(a => a.id === id)?.name;
    setApplicants(prev => prev.map(a => a.id === id ? {
      ...a,
      status
    } : a));
    const fn = status === 'Approved' ? toast.success : status === 'Rejected' ? toast.error : toast.info;
    fn(messages[status], {
      description: name
    });
  }, [applicants]);
  return <ApplicantsContext.Provider value={{
    applicants,
    setStatus
  }} data-id="element-664" data-mp="245jcs4k15ovu">{children}</ApplicantsContext.Provider>;
}
export function useApplicants(): ApplicantsContextValue {
  const ctx = useContext(ApplicantsContext);
  if (!ctx) throw new Error('useApplicants must be used within ApplicantsProvider');
  return ctx;
}